import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var path = process.env.VUE_APP_BASE_API;
import { getFileList } from '@/api/fileUploadAndDownload';
export default {
  props: {
    target: {
      type: Object,
      default: null
    },
    targetKey: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      drawer: false,
      picList: [],
      path: path
    };
  },
  methods: {
    chooseImg: function chooseImg(url, target, targetKey) {
      if (target && targetKey) {
        target[targetKey] = url;
      }

      this.$emit('enter-img', url);
      this.drawer = false;
    },
    open: function open() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getFileList({
                  page: 1,
                  pageSize: 9999
                });

              case 2:
                res = _context.sent;
                _this.picList = res.data.list;
                _this.drawer = true;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};